"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-allied-party" };
const _hoisted_2 = {
    key: 0,
    class: "allied-policy-block"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AlliedPartyAgenda = (0, vue_1.resolveComponent)("AlliedPartyAgenda");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.player.alliedParty)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createVNode)(_component_AlliedPartyAgenda, {
                    id: _ctx.player.alliedParty.agenda.policyId
                }, null, 8, ["id"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
